import { loanStatus } from '@/utils/dictionary'

export const LoanStatus = (value: string | number) => {
  const result = loanStatus.find(item => item.value === value + '')
  return result ? result.label : ''
}
